import { toast } from 'sonner';

export function buildShareLink(path: string, shareId: string): string {
  return `${window.location.origin}/${path}/${shareId}`;
}

export function buildCertificateLink(shareId: string): string {
  return buildShareLink('certificate', shareId);
}

function showManualCopyToast(text: string): void {
  toast.info('Copy this link manually:', { description: text, duration: 10000 });
}

export function copyToClipboard(text: string): void {
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text).then(
      () => toast.success('Link copied to clipboard'),
      () => showManualCopyToast(text)
    );
    return;
  }

  // execCommand('copy') is unreliable on non-secure origins (HTTP) —
  // browsers may report success but silently block the clipboard write.
  // Show the link for manual copy instead.
  showManualCopyToast(text);
}
